import React, { Component } from "react";
import { connect } from "react-redux";
import { filterSort } from "../../../actions";
import { getVisibleproducts } from "../../../services";

class FilterBar extends Component {
  //List Layout View
  listLayout() {
    const collectionGridView = document.querySelector(".collection-grid-view");
    const productWrapperGrid = document.querySelector(".product-wrapper-grid");
    if (collectionGridView && productWrapperGrid) {
      collectionGridView.style = "opacity:0";
      productWrapperGrid.style = "opacity:0.2";
      productWrapperGrid.classList.add("list-view");
      const elems = document.querySelector(".infinite-scroll-component .row")
        ?.childNodes;
      if (elems) {
        [].forEach.call(elems, function(el) {
          el.className = "";
          el.classList.add("col-lg-12");
        });
        setTimeout(function() {
          productWrapperGrid.style = "opacity: 1";
        }, 500);
      }
    }
  }

  //Grid Layout View
  gridLayout() {
    const collectionGridView = document.querySelector(".collection-grid-view");
    const productWrapperGrid = document.querySelector(".product-wrapper-grid");
    if (collectionGridView && productWrapperGrid) {
      collectionGridView.style = "opacity:1";
      productWrapperGrid.classList.remove("list-view");
      const elems = document.querySelector(".infinite-scroll-component .row")
        ?.childNodes;
      if (elems) {
        [].forEach.call(elems, function(el) {
          el.className = "";
          el.classList.add("col-lg-3");
        });
      }
    }
  }

  // Layout Column View
  LayoutView = (colSize, limit) => {
    const productWrapperGrid = document.querySelector(".product-wrapper-grid");
    if (
      productWrapperGrid &&
      !productWrapperGrid.classList.contains("list-view")
    ) {
      const elems = document.querySelector(".infinite-scroll-component .row")
        ?.childNodes;
      if (elems) {
        [].forEach.call(elems, function(el) {
          el.className = "";
          el.classList.add("col-lg-" + colSize);
        });
      }
    }

    this.props.onLayoutViewClicked(colSize, limit);
  };

  render() {
    console.log("FilterBar props:", this.props);
    return (
      <div className="product-filter-content">
        <div className="search-count">
          <h5>Showing Total Products {this.props.totalDocs}</h5>
        </div>
        <div className="collection-view">
          <ul>
            <li>
              <i
                className="fa fa-th grid-layout-view"
                onClick={this.gridLayout.bind(this)}
              />
            </li>
            {/* <li>
              <i
                className="fa fa-list-ul list-layout-view"
                onClick={this.listLayout.bind(this)}
              />
            </li> */}
          </ul>
        </div>
        <div className="collection-grid-view">
          <ul>
            <li>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/icon/2.png`}
                alt=""
                className="product-2-layout-view"
                onClick={() => this.LayoutView(3, 9)}
              />
            </li>
            <li>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/icon/3.png`}
                alt=""
                className="product-3-layout-view"
                onClick={() => this.LayoutView(4, 8)}
              />
            </li>
            <li>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/icon/4.png`}
                alt=""
                className="product-4-layout-view"
                onClick={() => this.LayoutView(3, 6)}
              />
            </li>
            <li>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/icon/6.png`}
                alt=""
                className="product-6-layout-view"
                onClick={() => this.LayoutView(2, 4)}
              />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  products: getVisibleproducts(state.data, state.filters),
  filters: state.filters,
});

export default connect(mapStateToProps, { filterSort })(FilterBar);